import PropTypes from "prop-types"
import { useState } from "react"
import { connect, useSelector } from "react-redux"

import { removeFromCart } from "app-store-v2/header/actions"
import { ShadowBox, ItemAction } from "areas/cart/components"
import { removeLineItem } from "areas/cart/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import Confirmation from "components/ui/confirmation"
import Media from "components/ui/media"
import { isTestMode, IS_JEWLR, jewlr_t } from "helpers/application"

import {
  CardProductImage,
  CardProductImageContainer,
  OutOfStockLabel,
} from "../components"
import GiftOptions from "../gift-wrap/gift-options"
import Price from "../jewlr/price"
import LineItemShipping from "../line-item-shipping"
import WarrantyAddon from "../warranty/warranty-addon"

import Addon from "./addon"
import LineItemInfo from "./line-item-info"

const InternalLineItemsDesktop = ({ item, removeAddonItem, removeItem }) => {
  const [showRemoveItemDialog, toggleRemoveItemDialog] = useState(false)
  const outOfStock = !item.in_stock
  const cartWarrantyExp = useSelector(
    (state) => state.experiment.cartWarranty.variant_id
  )

  return (
    <>
      <Media greaterThanOrEqual="tablet">
        <ShadowBox className="pb-8">
          <div className="mb-10 flex gap-10">
            <CardProductImageContainer outOfStock={outOfStock}>
              <CardProductImage
                alt={item.title}
                data-cy={`cart-line-item-img-${item.style_code}`}
                data-sku={item.sku}
                src={item.image_url}
                title={item.title}
              />
              {outOfStock && <OutOfStockLabel>Out Of Stock</OutOfStockLabel>}
            </CardProductImageContainer>
            <LineItemInfo
              item={item}
              toggleRemoveItemDialog={toggleRemoveItemDialog}
            />

            <div className="ml-auto text-right">
              {item.in_stock ? (
                <>
                  <Price dataCyType="desktop" item={item} />
                  <LineItemShipping item={item} />

                  {!item.reject_addons &&
                    IS_JEWLR() &&
                    sl.config.enable_gift_preview_video && (
                      <Button
                        className="text-12 leading-14 tracking-tigher my-8 text-right font-medium"
                        onClick={() => {
                          openModal(`#gift-preview-video-${item.id}`)
                          if (!isTestMode) {
                            dataLayer.push({
                              event: "clicked-need-it-now-cart",
                            })
                          }
                        }}
                        text
                        underline
                        variant="secondary"
                      >
                        Need it now?
                        <br />
                        Send a Gift Preview Video
                      </Button>
                    )}
                </>
              ) : (
                <ItemAction
                  className="font-medium"
                  data-cy={`cart-remove-btn-${item.style_code}`}
                  onClick={() => toggleRemoveItemDialog(true)}
                >
                  Remove from {jewlr_t("Cart")}
                </ItemAction>
              )}
            </div>
          </div>

          {IS_JEWLR() && item.in_stock && (
            <>
              <Addon
                boxAddon={item.addons.find((a) => a.addon_type === "BOX_PRINT")}
                item={item}
                removeAddonItem={removeAddonItem}
              />
              {cartWarrantyExp === 1 ? (
                <>
                  {!item.reject_addons && sl.config.enable_extend_warranty && (
                    <WarrantyAddon item={item} />
                  )}
                  {!item.reject_addons && <GiftOptions item={item} />}
                </>
              ) : (
                <>
                  {!item.reject_addons && <GiftOptions item={item} />}
                  {!item.reject_addons && sl.config.enable_extend_warranty && (
                    <WarrantyAddon item={item} />
                  )}
                </>
              )}
            </>
          )}
        </ShadowBox>
      </Media>
      <Confirmation
        cancelText="Cancel"
        confirmText="Yes"
        description={`Are you sure you want to remove this item from your ${jewlr_t("Cart")}?`}
        modalType="popup"
        onCancel={() => toggleRemoveItemDialog(false)}
        onConfirm={() => {
          removeItem(item.id)
          toggleRemoveItemDialog(false)
        }}
        show={showRemoveItemDialog}
        title="Remove Item"
      />
    </>
  )
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeAddonItem: (addonId) => {
      dispatch(removeFromCart(addonId, true))
    },
    removeItem: (itemId) => {
      dispatch(removeLineItem(itemId, "product"))
    },
  }
}

InternalLineItemsDesktop.propTypes = {
  item: PropTypes.object,
  removeAddonItem: PropTypes.func,
  removeItem: PropTypes.func,
}

const LineItemsDesktop = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalLineItemsDesktop)

export default LineItemsDesktop
